module.exports = __webpack_public_path__ + "img/8.ca9160ae.png";